import type { TimeRangeConfig } from '@/types/dashboard';

export interface TimeRangePreset {
  key: string;
  label: string;
  getConfig: () => TimeRangeConfig;
}

function startOfMonth(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-01`;
}

function endOfMonth(date: Date): string {
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return `${lastDay.getFullYear()}-${String(lastDay.getMonth() + 1).padStart(2, '0')}-${String(lastDay.getDate()).padStart(2, '0')}`;
}

export const TIME_RANGE_PRESETS: TimeRangePreset[] = [
  {
    key: 'last_7_days',
    label: 'Last 7 days',
    getConfig: () => ({ type: 'last_n_days', value: 7 }),
  },
  {
    key: 'last_30_days',
    label: 'Last 30 days',
    getConfig: () => ({ type: 'last_n_days', value: 30 }),
  },
  {
    key: 'last_90_days',
    label: 'Last 90 days',
    getConfig: () => ({ type: 'last_n_days', value: 90 }),
  },
  {
    key: 'this_month',
    label: 'This month',
    getConfig: () => {
      const now = new Date();
      return {
        type: 'specific_range',
        start_date: startOfMonth(now),
        end_date: endOfMonth(now),
      };
    },
  },
  {
    key: 'last_month',
    label: 'Last month',
    getConfig: () => {
      const now = new Date();
      const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      return {
        type: 'specific_range',
        start_date: startOfMonth(prev),
        end_date: endOfMonth(prev),
      };
    },
  },
  {
    key: 'last_2_weeks',
    label: 'Last 2 weeks',
    getConfig: () => ({ type: 'last_n_weeks', value: 2 }),
  },
];

export function getPresetByKey(key: string): TimeRangePreset | undefined {
  return TIME_RANGE_PRESETS.find((p) => p.key === key);
}
